/**
 * @desc 解冻库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/stockFreezeRecord/unfreeze`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
